export default __webpack_public_path__ + "static/media/phone-card-icon.5042cdd1.svg";